<template>
  <div class="home mt-2">
    <entity-header
      title="Billing Codes"
      :show-filters="true"
      :show-export="true"
      :has-active-filters="hasActiveFilters"
      @export="getBillingCodesExcel"
      :show-new="true"
      new-label="Nuevo Billing Code"
      new-tooltip="Nuevo Billing Code"
      @search="billingCodesBuscar"
      @new="showEdit({}, 'add')"
    >
      <template #filters>
        <div class="form-group col mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="criterio_cod_tas">Por Código TAS</label>
          <input
            type="text"
            class="form-control"
            id="criterio_cod_tas"
            v-model="criterio.cod_tas"
            placeholder="Código TAS..."
            @keyup.enter="billingCodesBuscar()"
            aria-label="Código TAS"
          />
        </div>
        <div class="form-group col mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="criterio_descripcion">Por Descripción</label>
          <input
            type="text"
            class="form-control"
            id="criterio_descripcion"
            v-model="criterio.descripcion"
            placeholder="Descripción..."
            @keyup.enter="billingCodesBuscar()"
            aria-label="Descripción"
          />
        </div>
      </template>
    </entity-header>
    <div class="alert alert-success" role="alert" v-if="success">{{ success }}</div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>
    <data-table
      v-if="billingCodesBusqueda && billingCodesBusqueda.data && billingCodesBusqueda.data.length"
      :columns="columns"
      :data="billingCodesBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_billing_code"
      :show-actions="isAdmin()"
      actions-width="110"
      @sort="orderByfield"
    >
      <template #cell-integrador="{ item, value }">
        {{ value || getIntegradorName(item.id_integrador) }}
      </template>

      <template #actions="{ item }">
        <table-actions
          :item="item"
          active-key="activo"
          @edit="showEdit(item, 'edit')"
          @toggle="showEdit(item, 'toggle')"
        />
      </template>
    </data-table>
    <Paginador v-if="billingCodesBusqueda && billingCodesBusqueda.pages" :pages="billingCodesBusqueda.pages" @selPage="changePage"></Paginador>
    <empty-state
      :show="Boolean(post && !(billingCodesBusqueda && billingCodesBusqueda.data && billingCodesBusqueda.data.length))"
      message="No se encontraron billing codes con el criterio seleccionado."
    />
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal CRUD Estandarizado -->
    <crud-modal
      :show="showModal"
      :title="modalTitle"
      :is-toggle="operation == 'toggle'"
      :show-save="operation == 'edit' || operation == 'add' || operation == 'toggle'"
      :save-text="modalSaveText"
      :save-variant="operation == 'toggle' ? (editData && editData.activo == 1 ? 'warning' : 'success') : 'primary'"
      @close="closeModal"
      @save="onModalSave"
    >

      <form v-if="editData && (operation == 'edit' || operation == 'add')" @submit.prevent="onModalSave">
        <div v-if="operation == 'add' && isTodosIntegrador" class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Integrador <span class="text-danger">*</span></label>
          <select class="form-control" name="id_integrador" v-model="editData.id_integrador" required>
            <option :value="null">Seleccione un integrador...</option>
            <option
              v-for="item in integradoresList"
              :key="item.id_integrador || item.id"
              :value="item.id_integrador || item.id"
            >
              {{ item.integrador }}
            </option>
          </select>
          <small class="form-text text-muted">Seleccione el integrador para este billing code.</small>
        </div>
        <div v-else-if="operation == 'edit'" class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Integrador</label>
          <input
            type="text"
            class="form-control"
            :value="editData.integrador || getIntegradorName(editData.id_integrador)"
            disabled
            readonly
          />
          <small class="form-text text-muted">Integrador al que pertenece el billing code (no editable).</small>
        </div>
        <div v-else-if="operation == 'add'" class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Integrador</label>
          <input
            type="text"
            class="form-control"
            :value="getIntegradorName(criterio.id_integrador)"
            disabled
            readonly
          />
          <small class="form-text text-muted">Integrador seleccionado para el nuevo billing code (no editable).</small>
        </div>

        <div class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Código TAS <span class="text-danger">*</span></label>
          <input
            class="form-control"
            name="cod_tas"
            type="text"
            placeholder="Ej: TAS01"
            v-model="editData.cod_tas"
          />
          <small class="form-text text-muted">Código TAS identificador del billing code (ej: TAS01).</small>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="font-weight-bold small text-muted mb-1">Precio Sin Impuesto</label>
            <price-input
              name="precio_sin_imp"
              placeholder="0.00"
              v-model="editData.precio_sin_imp"
            />
            <small class="form-text text-muted">Valor monetario sin impuestos (número decimal, ej: 10.00).</small>
          </div>

          <div class="form-group col-md-6">
            <label class="font-weight-bold small text-muted mb-1">Precio Con Impuesto</label>
            <price-input
              name="precio_con_imp"
              placeholder="0.00"
              v-model="editData.precio_con_imp"
            />
            <small class="form-text text-muted">Valor monetario con impuestos incluidos (número decimal, ej: 11.80).</small>
          </div>
        </div>

        <div class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Descripción</label>
          <textarea
            class="form-control"
            name="descripcion"
            placeholder="Ej: Cobro diario suscripción"
            v-model="editData.descripcion"
          />
          <small class="form-text text-muted">Nombre o descripción representativa del billing code.</small>
        </div>

        <div v-if="errors" class="alert alert-danger" role="alert">
          <i class="bi bi-exclamation-triangle me-1"></i>
          {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
        </div>
      </form>
    </crud-modal>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import EntityHeader from "./utiles/EntityHeader.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import CrudModal from "./utiles/CrudModal.vue";
import PriceInput from "./utiles/PriceInput.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";

export default {
  name: "BillingCodes",
  mixins: [tableSortMixin],

  data() {
    return {
      columns: [
        { label: "Id", field: "id_billing_code", width: "80" },
        { label: "Integrador", field: "integrador" },
        { label: "Código TAS", field: "cod_tas" },
        {
          label: "Precio Sin Imp",
          field: "precio_sin_imp",
          formatter: (val) => this.formatPrice(val),
        },
        {
          label: "Precio Con Imp",
          field: "precio_con_imp",
          formatter: (val) => this.formatPrice(val),
        },
        { label: "Descripción", field: "descripcion" },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      success: null,
      error: null,
      criterio: {
        cod_tas: null,
        descripcion: null,
        id_integrador: localStorage.getItem('integrador'),
      },
      billingCodesBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      pages: null
    };
  },

  components: {
    EntityHeader,
    DataTable,
    Paginador,
    TableActions,
    EmptyState,
    CrudModal,
    PriceInput,
  },

  created() {
    this.orderByField = "id_billing_code";
    this.getBillingCodesBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),
    modalTitle() {
      if (this.operation === "add") return "Nuevo Billing Code";
      if (this.operation === "edit") {
        return `Editar Billing Code ${this.editData ? this.editData.id_billing_code : ""}`;
      }
      if (this.operation === "toggle") {
        return this.editData && this.editData.activo == 1
          ? "Suspender Billing Code"
          : "Reactivar Billing Code";
      }
      return "";
    },
    modalSaveText() {
      if (this.operation === "toggle") {
        return this.editData && this.editData.activo == 1 ? "Suspender" : "Reactivar";
      }
      return "Guardar";
    },
    hasActiveFilters() {
      return Boolean(this.criterio.cod_tas) || Boolean(this.criterio.descripcion);
    },

    isTodosIntegrador() {
      return !this.criterio.id_integrador || this.criterio.id_integrador === "todos";
    },

    integradoresList() {
      let list = [];
      if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
        list = [...this.integradores.data];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },
  },

  watch: {
    "$store.state.integrador.integrador"(newVal) {
      this.criterio.id_integrador = newVal;
      this.page = 1;
      this.getBillingCodesBusqueda();
    },
  },

  methods: {
    formatPrice(val) {
      if (val === null || val === undefined || val === "") return "-";
      const cleaned = String(val).replace(/^\$\s*/, "").trim();
      const num = Number(cleaned);
      if (isNaN(num)) return cleaned;
      return num.toFixed(2);
    },

    getIntegradorName(id) {
      if (!id) return "";
      const list = this.integradores && this.integradores.data ? this.integradores.data : (Array.isArray(this.integradores) ? this.integradores : []);
      const found = list.find((i) => String(i.id_integrador || i.id) === String(id));
      return found ? found.integrador : id;
    },
    onModalSave() {
      if (this.operation === "add") {
        this.agregarBillingCode();
      } else if (this.operation === "edit") {
        this.editBillingCode();
      } else if (this.operation === "toggle") {
        this.toggleStatus();
      }
    },
    billingCodesBuscar: function() {
      this.changePage(1);
    },

    changePage: function(page) {
      this.page = page;
      this.getBillingCodesBusqueda(false);
    },

    orderByfield: function(field) {
      this.toggleOrder(field);
      this.getBillingCodesBusqueda(false);
    },

    getBillingCodesBusqueda: function(hideResult = true) {
      if (hideResult) this.billingCodesBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/busqueda", {
          page: this.page,
          id_integrador: this.criterio.id_integrador,
          cod_tas: this.criterio.cod_tas,
          descripcion: this.criterio.descripcion,
          order_by: { field: this.orderByField, order: this.orderByDirection }
        })
        .then(response => {
          this.billingCodesBusqueda = response.data;
        })
        .catch(e => {
          this.errors.push(e);
           if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar los códigos de facturación",
            icon: "error",
            confirmButtonText: "Aceptar"
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    deleteBillingCode: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/delete", {
          id_billing_code: this.editData.id_billing_code
        })
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar eliminar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },
    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      const targetActivo = 1 - Number(this.editData.activo || 0);
      const payload = {
        ...this.editData,
        activo: targetActivo,
      };
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/update", payload)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Billingcode actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },
    editBillingCode: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);

      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/update", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "BillingCode actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && (e.response.data.error || e.response.data.errors)) {
            this.errors = e.response.data.error || e.response.data.errors;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },
      isAdmin() {
      return this.user && this.user.rol == "admin";
    },  
    showEdit: function(item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      if (operation === 'add') {
        this.editData = {
          id_integrador: this.isTodosIntegrador
            ? null
            : parseInt(this.criterio.id_integrador),
          cod_tas: "",
          descripcion: "",
          precio_sin_imp: "",
          precio_con_imp: "",
          activo: 1,
        };
      }
      this.showModal = true;
      this.operation = operation;
    },

    getBillingCodesExcel: function () {
      startAsyncExport("billingcode", {
        id_integrador: this.criterio.id_integrador,
        order_by: {
          field: this.orderByField,
          order: this.orderByDirection,
        },
      }, "BillingCodes");
    },

    agregarBillingCode: function() {
      this.errors = null;
      if (!this.editData.id_integrador || this.editData.id_integrador === "todos") {
        if (!this.isTodosIntegrador) {
          this.editData.id_integrador = parseInt(this.criterio.id_integrador);
        } else {
          this.errors = "Debe seleccionar un integrador para el nuevo billing code";
          return;
        }
      }
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/new", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "BillingCode creada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch(e => {
          if (e.response && e.response.data && (e.response.data.error || e.response.data.errors)) {
            this.errors = e.response.data.error || e.response.data.errors;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
      this.editData = null;
      this.errors = null;
    }
  }
};
</script>

<style scoped></style>
